(() => {
  const copy = document.getElementById('skr-account-copy')?.dataset;
  const source = document.getElementById('skr-account-labels');
  if (!copy || !source) return;
  let labels;
  try {
    labels = JSON.parse(source.textContent);
    const decoder = document.createElement('textarea');
    Object.keys(labels).forEach(key => { decoder.innerHTML = labels[key]; labels[key] = decoder.value; });
  } catch { return; }
  const make = (tag, cls, text = '') => {
    const el = document.createElement(tag);
    el.className = cls;
    el.textContent = text;
    return el;
  };
  const icon = name => document.getElementById('skr-account-icons-template')?.content.querySelector(`[data-icon="${name}"] svg`)?.cloneNode(true);
  const request = new URL(location.href).searchParams.get('account_request');
  const contactForm = document.getElementById('SKRContactForm');
  if (contactForm && ['access', 'copy', 'delete', 'return'].includes(request)) {
    const subject = labels[`request_${request}`];
    const select = contactForm.querySelector('select[name="contact[Onderwerp]"]');
    const body = contactForm.querySelector('textarea[name="contact[Reactie]"]');
    if (select) {
      let option = Array.from(select.options).find(o => o.value === subject);
      if (!option) { option = new Option(subject, subject); select.add(option); }
      select.value = subject;
    }
    if (body && !body.value.trim()) body.value = labels[`body_${request}`] + (copy.klantnummer ? `\n\n${labels.number}: ${copy.klantnummer}` : '');
    const note = make('aside', 'skr-bol-request-note');
    note.append(make('strong', '', subject), make('p', '', labels.request_note));
    const back = make('a', '', labels.request_back);
    back.href = '/apps/customerdashboard?skr_view=' + (request === 'return' ? 'returns' : 'privacy');
    note.append(back);
    contactForm.prepend(note);
  }
  if (!location.pathname.includes('/apps/customerdashboard')) return;
  document.body.classList.add('skr-bol-account');
  const allowed = ['settings', 'privacy', 'returns', 'club'];
  const readRoute = () => {
    const url = new URL(location.href);
    const view = url.searchParams.get('skr_view');
    if (allowed.includes(view)) return view;
    if (view === 'overview') return null;
    return !url.search || url.search === '?cd_my-profile' ? 'settings' : null;
  };
  let customView = readRoute();
  let shell;
  let lastTrigger;
  const applyView = () => {
    if (!shell) return;
    shell.dataset.skrScreen = customView ? 'custom' : 'native';
    if (customView === 'returns') {
      const frame = shell.querySelector('[data-skr-return-frame]');
      if (frame && !frame.hasAttribute('src')) frame.src = frame.dataset.src;
    }
    shell.querySelectorAll('[data-skr-custom]').forEach(view => { view.hidden = view.dataset.skrCustom !== customView; });
    shell.querySelectorAll('[data-skr-nav]').forEach(nav => {
      const active = nav.dataset.skrNav === (customView === 'privacy' ? 'settings' : customView);
      if (active) nav.setAttribute('aria-current', 'page'); else nav.removeAttribute('aria-current');
    });
    shell.querySelectorAll('.custlo-t1-tab').forEach(nav => {
      if (!customView && nav.classList.contains('custlo-t1-active')) nav.setAttribute('aria-current', 'page'); else nav.removeAttribute('aria-current');
    });
    const crumb = shell.querySelector('[data-skr-crumb]');
    if (crumb) crumb.textContent = customView ? labels[customView] : (shell.querySelector('.custlo-t1-tab.custlo-t1-active')?.textContent.trim() || labels.overview);
  };
  const navigate = (view, trigger) => {
    customView = view;
    const url = new URL(location.href);
    url.search = '';
    url.searchParams.set('skr_view', view);
    history.pushState({}, '', url);
    applyView();
    if (trigger) lastTrigger = trigger;
    const title = shell?.querySelector(`[data-skr-custom="${view}"] h1`);
    if (title) { title.tabIndex = -1; title.focus({ preventScroll: true }); window.scrollTo({top:0,behavior:'auto'}); }
  };
  const native = (type, newsletter = false) => {
    customView = null;
    applyView();
    const target = type === 'profile' ? shell.querySelector('#custlo-t1-edit-profile-btn') : shell.querySelector(`.custlo-t1-tab[data-type="${type}"]`);
    target?.click();
    if (newsletter) requestAnimationFrame(() => {
      const input = shell.querySelector('#custlo-t1-accepts-marketing');
      input?.focus();
      input?.scrollIntoView({ block: 'center', behavior: 'auto' });
    });
  };
  let cookieDialog;
  const openCookies = trigger => {
    if (!cookieDialog) {
      cookieDialog = document.getElementById('skr-account-cookie-template').content.firstElementChild.cloneNode(true);
      document.body.append(cookieDialog);
      cookieDialog.querySelector('[data-skr-cookie-cancel]').addEventListener('click', () => cookieDialog.close());
      cookieDialog.addEventListener('close', () => lastTrigger?.focus());
      cookieDialog.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const save = cookieDialog.querySelector('[type="submit"]');
        const status = cookieDialog.querySelector('[data-skr-cookie-status]');
        const api = window.Shopify?.customerPrivacy;
        if (!api?.setTrackingConsent) { status.textContent = labels.cookie_error; return; }
        save.disabled = true;
        const values = Object.fromEntries(['analytics','marketing','preferences'].map(key => [key, cookieDialog.querySelector(`[name="${key}"]`).checked]));
        let complete = false;
        const failed = () => { complete = true; save.disabled = false; status.textContent = labels.cookie_error; };
        const timer = setTimeout(() => { if (!complete) failed(); }, 8000);
        try {
          api.setTrackingConsent(values, () => {
            clearTimeout(timer);
            const saved = api.currentVisitorConsent();
            const valid = Object.entries(values).every(([key, value]) => saved[key] === (value ? 'yes' : 'no'));
            complete = true;
            save.disabled = false;
            status.textContent = valid ? labels.cookie_saved : labels.cookie_error;
          });
        } catch { clearTimeout(timer); failed(); }
      });
    }
    lastTrigger = trigger;
    const status = cookieDialog.querySelector('[data-skr-cookie-status]');
    const inputs = ['analytics','marketing','preferences'].map(key => cookieDialog.querySelector(`[name="${key}"]`));
    inputs.forEach(input => { input.disabled = true; });
    cookieDialog.querySelector('[type="submit"]').disabled = true;
    status.textContent = labels.loading;
    cookieDialog.showModal();
    const ready = error => {
      if (error || !window.Shopify?.customerPrivacy?.currentVisitorConsent) { status.textContent = labels.cookie_error; return; }
      const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      inputs.forEach(input => { input.checked = consent[input.name] === 'yes'; input.disabled = false; });
      cookieDialog.querySelector('[type="submit"]').disabled = false;
      status.textContent = '';
    };
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) ready();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], ready);
    else ready(true);
  };
  const bind = dashboard => {
    dashboard.addEventListener('click', event => {
      const action = event.target.closest('[data-skr-action]');
      if (action) {
        const type = action.dataset.skrAction;
        if (allowed.includes(type)) {
          event.preventDefault();
          navigate(type, action);
        }
        else if (type === 'security') {
          const details = dashboard.querySelector('#skr-security-details');
          details.hidden = !details.hidden;
          action.setAttribute('aria-expanded', String(!details.hidden));
          action.setAttribute('aria-controls', details.id);
        } else if (type === 'cookies') openCookies(action);
        else if (type === 'newsletter') native('profile', true);
        else if (type === 'favorites') document.querySelector('.header__icon--wishlist')?.click();
        else native(type);
        return;
      }
      const tab = event.target.closest('.custlo-t1-router-link');
      if (tab) {
        customView = null;
        applyView();
        queueMicrotask(() => {
          const url = new URL(location.href);
          url.searchParams.delete('skr_view');
          if (tab.dataset.type === 'profile') url.searchParams.set('skr_view','overview');
          history.replaceState(history.state, '', url);
          applyView();
        });
      }
    }, true);
  };
  const navItem = (key, ico, action, href) => {
    const nav = make(href ? 'a' : 'button', 'skr-bol-nav');
    if (href) nav.href = href;
    else { nav.type = 'button'; nav.dataset.skrAction = action; nav.dataset.skrNav = action; }
    const image = icon(ico);
    if (image) nav.append(image);
    nav.append(make('span','', labels[key]));
    return nav;
  };
  const enhanceReturnLinks = () => {
    if (!shell) return;
    const linkFor = (id, context) => {
      const link = make('a', 'skr-native-return-link', labels.return_action);
      link.href = '/apps/customerdashboard?skr_view=returns';
      link.dataset.skrAction = 'returns';
      link.dataset.skrNativeReturn = context;
      link.title = labels.return_page_note;
      return link;
    };
    shell.querySelectorAll('[id^="custlo-t1-order-detail-view-"]').forEach(view => {
      const id = view.id.match(/^custlo-t1-order-detail-view-(\d+)$/)?.[1];
      const actions = view.querySelector('.custlo-t1-order-detail-actions');
      if (id && actions && !actions.querySelector('[data-skr-native-return]')) actions.append(linkFor(id, 'detail'));
    });
    shell.querySelectorAll('[id^="custlo-ro2-card-"]').forEach(card => {
      const id = card.id.match(/^custlo-ro2-card-(\d+)$/)?.[1];
      const actions = card.querySelector('.custlo-ro2-acts');
      if (id && card.querySelector('.b2-ful') && actions && !actions.querySelector('[data-skr-native-return]')) actions.append(linkFor(id, 'card'));
    });
  };
  const enhance = () => {
    shell = document.getElementById('customer_dashboard');
    if (!shell) return;
    const nav = shell.querySelector('.custlo-t1-nav-scroll-wrapper');
    const tabs = shell.querySelector('.custlo-t1-tabs-scroll-inner');
    const content = shell.querySelector('.custlo-t1-content-area');
    if (!nav || !tabs || !content) return;
    if (!shell.classList.contains('skr-bol-shell')) {
      shell.classList.add('skr-bol-shell');
      nav.setAttribute('role','navigation');
      nav.setAttribute('aria-label',labels.account);
      const crumb = make('nav','skr-bol-breadcrumb');
      crumb.setAttribute('aria-label',labels.account);
      const home = make('a','',labels.home); home.href = '/';
      const here = make('span',''); here.dataset.skrCrumb = ''; here.setAttribute('aria-current','page');
      crumb.append(home,make('span','','/'),make('span','',labels.account),make('span','','/'),here);
      shell.prepend(crumb);
      const identity = make('div','skr-bol-identity');
      const avatar = make('span','skr-bol-avatar'); avatar.append(icon('person'));
      const identityText = make('div','');
      identityText.append(make('strong','',copy.customerName || labels.account),make('p','',labels.account));
      identity.append(avatar,identityText); nav.prepend(identity);
      const primary = {orders:'nav_orders',address:'nav_addresses'};
      const nativeTabs = {};
      const more = make('details','skr-bol-more'); more.append(make('summary','',labels.more));
      const bottom = make('div','skr-bol-nav-bottom'); bottom.append(navItem('back_shop','home',null,'/'));
      Array.from(tabs.querySelectorAll('.custlo-t1-tab')).forEach(tab => {
        if (primary[tab.dataset.type]) {
          nativeTabs[tab.dataset.type] = tab;
          Array.from(tab.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
          const text = tab.querySelector('.custlo-t1-tab-text') || make('span','custlo-t1-tab-text');
          text.textContent = labels[primary[tab.dataset.type]];
          if (!text.parentElement) tab.append(text);
        } else if (tab.classList.contains('custlo-t1-mobile-logout')) bottom.append(tab);
        else more.append(tab);
      });
      const club = navItem('club','crown','club');
      club.classList.add('skr-club-nav');
      if (nativeTabs.orders) tabs.append(nativeTabs.orders);
      tabs.append(navItem('nav_favorites','heart','favorites'),navItem('nav_returns','return','returns'),club);
      if (nativeTabs.address) tabs.append(nativeTabs.address);
      tabs.append(navItem('nav_settings','security','settings'));
      more.append(navItem('service','help',null,copy.supportUrl));
      nav.append(more,bottom);
      const help = make('aside','skr-bol-help');
      help.append(make('strong','',labels.help),make('p','',labels.help_text));
      const link = make('a','skr-bol-action',labels.contact);link.href=copy.supportUrl;help.append(link);nav.append(help);
      for (const view of allowed) {
        const template = document.getElementById(`skr-account-${view === 'settings' ? 'settings' : view}-template`);
        if (template) content.append(template.content.cloneNode(true));
      }
      const number = shell.querySelector('[data-skr-number]');
      if (number && copy.klantnummer) { number.textContent = labels.number + ': ' + copy.klantnummer; number.hidden = false; }
      const security = shell.querySelector('[data-skr-action="security"]');
      security?.setAttribute('aria-expanded','false');
      security?.setAttribute('aria-controls','skr-security-details');
      bind(shell);
    }
    const main = shell.querySelector('#custlo-t1-main-view');
    if (main && !main.querySelector('.skr-account-intro')) {
      const intro = make('div','skr-account-intro');
      intro.append(make('h1','skr-account-intro-title',labels.overview),make('p','skr-account-intro-text',labels.overview_text));
      main.prepend(intro);
      if (copy.klantnummer) intro.after(make('div','skr-account-number',labels.number + ': ' + copy.klantnummer));
    }
    const edit = shell.querySelector('#custlo-t1-edit-profile-btn');
    if (edit && !edit.querySelector('.skr-account-edit-label')) {
      edit.setAttribute('aria-label',labels.personal_action);
      edit.append(make('span','skr-account-edit-label',labels.personal_action));
    }
    enhanceReturnLinks();
    applyView();
  };
  const mount = document.getElementById('custlo-portal-mount') || document.getElementById('MainContent');
  const options = { childList:true, subtree:true, attributes:true, attributeFilter:['class','style'] };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      observer.disconnect();
      enhance();
      if (mount) observer.observe(mount,options);
    });
  });
  enhance();
  if (mount) observer.observe(mount,options);
  addEventListener('popstate', () => { customView = readRoute(); applyView(); });
})();

(() => {
  if (!location.pathname.includes('/apps/customerdashboard')) return;
  const source = document.getElementById('skr-account-labels');
  if (!source) return;
  let labels;
  try { labels = JSON.parse(source.textContent); } catch { return; }
  const text = key => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = labels[`invoice_${key}`] || key;
    return decoder.value;
  };
  const node = (tag, cls, value = '') => {
    const el = document.createElement(tag);
    el.className = cls;
    el.textContent = value;
    return el;
  };
  const loadPdfLibrary = (url, ready) => {
    if (ready()) return Promise.resolve();
    return new Promise((resolve, reject) => {
      let script = [...document.scripts].find(el => el.src === url);
      const created = !script;
      if (created) {
        script = document.createElement('script');
        script.src = url;
        script.async = true;
      }
      const timer = setTimeout(() => reject(new Error('PDF library load timed out')), 15000);
      script.addEventListener('load', () => {
        clearTimeout(timer);
        if (ready()) resolve();
        else reject(new Error('PDF library unavailable'));
      }, {once: true});
      script.addEventListener('error', () => {
        clearTimeout(timer);
        if (created) script.remove();
        reject(new Error('PDF library could not load'));
      }, {once: true});
      if (created) document.head.append(script);
    });
  };
  const exportPdf = async (root, button) => {
    const modal = root.closest('.custlo-t1-invoice-modal-preview');
    if (button.disabled) return;
    button.disabled = true;
    button.textContent = text('processing');
    modal.querySelector('.skr-invoice-error')?.remove();
    let host;
    try {
      await Promise.all([
        loadPdfLibrary('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js', () => typeof window.html2canvas === 'function'),
        loadPdfLibrary('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js', () => typeof window.jspdf?.jsPDF === 'function')
      ]);
      host = node('div', 'skr-invoice-export-host');
      host.setAttribute('aria-hidden', 'true');
      host.style.cssText = 'position:absolute;left:-10000px;top:0;width:794px;background:white;pointer-events:none;';
      const copy = root.cloneNode(true);
      copy.removeAttribute('id');
      copy.classList.add('skr-invoice-export');
      host.append(copy);
      document.body.append(host);
      await Promise.allSettled([...copy.querySelectorAll('img')].map(img => img.decode()));
      const bounds = copy.getBoundingClientRect();
      const blocks = [...copy.querySelectorAll('thead, tbody tr, .skr-invoice-info, .skr-invoice-totals, .skr-invoice-footer')].map(el => {
        const rect = el.getBoundingClientRect();
        return {top: rect.top - bounds.top, bottom: rect.bottom - bounds.top};
      });
      const canvas = await window.html2canvas(copy, {scale: 2, useCORS: true, backgroundColor: '#ffffff', windowWidth: 1200, scrollX: 0, scrollY: 0});
      const pdf = new window.jspdf.jsPDF({orientation: 'portrait', unit: 'mm', format: 'a4'});
      const pageHeight = Math.floor(canvas.width * 277 / 190);
      const ratio = canvas.width / bounds.width;
      let start = 0;
      while (start < canvas.height) {
        let end = Math.min(start + pageHeight, canvas.height);
        const crossing = blocks.find(block => block.top * ratio > start + 1 && block.top * ratio < end && block.bottom * ratio > end);
        if (crossing) end = Math.floor(crossing.top * ratio);
        if (end <= start) end = Math.min(start + pageHeight, canvas.height);
        const page = document.createElement('canvas');
        page.width = canvas.width;
        page.height = end - start;
        page.getContext('2d').drawImage(canvas, 0, start, canvas.width, page.height, 0, 0, canvas.width, page.height);
        if (start) pdf.addPage();
        pdf.addImage(page.toDataURL('image/jpeg', 0.95), 'JPEG', 10, 10, 190, page.height * 190 / page.width);
        start = end;
      }
      const order = root.querySelector('.skr-invoice-heading p')?.textContent.match(/#[\w-]+/)?.[0].replace('#', '') || 'bestelling';
      pdf.save(`Samen-KR-Factuur-${order}.pdf`);
    } catch (error) {
      console.warn('Samen K&R invoice export:', error.message);
      const status = node('p', 'skr-invoice-error', text('error'));
      status.setAttribute('role', 'alert');
      button.before(status);
    } finally {
      host?.remove();
      button.disabled = false;
      button.textContent = text('download');
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.custlo-t1-invoice-download-from-preview');
    const root = button?.closest('[data-skr-invoice]')?.querySelector('.skr-invoice-document');
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void exportPdf(root, button);
  }, true);
  const enhance = () => {
    document.querySelectorAll('.custlo-t1-invoice-modal-preview').forEach(modal => {
      if (modal.dataset.skrInvoice) return;
      const root = modal.querySelector('#classic-invoice');
      if (!root) return;
      modal.dataset.skrInvoice = 'true';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', text('preview'));
      const title = modal.querySelector('h3');
      if (title) title.textContent = text('preview');
      const close = modal.querySelector('.custlo-t1-invoice-close-preview');
      if (close) close.textContent = text('close');
      const download = modal.querySelector('.custlo-t1-invoice-download-from-preview');
      if (download) download.textContent = text('download');
      root.classList.add('skr-invoice-document');
      const [header, info] = root.children;
      const order = info?.children[1]?.querySelectorAll('p')[2]?.textContent.split(':').slice(1).join(':').trim() || '';
      if (header) {
        header.className = 'skr-invoice-header';
        header.replaceChildren();
        const brand = node('div', 'skr-invoice-brand');
        const logoSource = document.querySelector('.skr-header-logo') || document.querySelector('.header__heading-logo, header .header__heading-link img, header a[href="/"] img');
        if (logoSource) {
          const logo = document.createElement('img');
          logo.src = logoSource.currentSrc || logoSource.src;
          logo.alt = 'Samen K&R';
          logo.width = 190;
          logo.className = 'skr-invoice-logo';
          brand.append(logo);
        } else brand.append(node('strong', 'skr-invoice-store', 'Samen K&R'));
        brand.append(node('p', 'skr-invoice-address', 'Anna Bijnslaan 37 · 2531 VT Den Haag'), node('p', 'skr-invoice-contact', 'info@samenkr.com · samenkr.com'));
        const heading = node('div', 'skr-invoice-heading');
        heading.append(node('h1', '', text('title')));
        if (order) heading.append(node('p', '', `${text('order')} ${order}`));
        header.append(brand, heading);
      }
      if (info) {
        info.className = 'skr-invoice-info';
        const recipient = info.children[0];
        const details = info.children[1];
        if (recipient) {
          recipient.className = 'skr-invoice-recipient';
          recipient.querySelector('p').textContent = text('recipient');
        }
        if (details) {
          details.className = 'skr-invoice-details';
          details.querySelector('p').textContent = text('details');
          const strong = details.querySelector('strong');
          if (strong) strong.textContent = `${text('date')}:`;
          const status = details.querySelector('span');
          if (status && labels[`invoice_status_${status.textContent.trim().toLowerCase()}`]) status.textContent = text(`status_${status.textContent.trim().toLowerCase()}`);
          const customerNumber = document.getElementById('skr-account-copy')?.dataset.klantnummer?.trim();
          if (customerNumber) {
            const numberLabel = document.createElement('textarea');
            numberLabel.innerHTML = labels.number || 'Klantnummer';
            const numberRow = node('p', 'skr-invoice-customer-number');
            numberRow.append(node('strong', '', numberLabel.value + ':'), document.createTextNode(' ' + customerNumber));
            details.append(numberRow);
          }
        }
      }
      const table = root.querySelector('.custlo-t1-invoice-table');
      if (table) {
        const columns = ['product', 'quantity', 'price', 'amount'];
        table.querySelectorAll('thead th').forEach((th, index) => { th.textContent = text(columns[index]); });
        table.querySelectorAll('tbody tr').forEach(row => {
          row.querySelectorAll('td').forEach((td, index) => { if (index) td.dataset.label = text(columns[index]); });
          row.querySelectorAll('img').forEach(img => { img.alt = row.querySelector('.custlo-t1-invoice-product_title')?.textContent.trim() || text('product'); });
        });
        table.parentElement.classList.add('skr-invoice-products');
      }
      const footer = root.lastElementChild;
      if (footer) {
        const totals = footer.previousElementSibling;
        if (totals) {
          totals.classList.add('skr-invoice-totals-wrap');
          totals.firstElementChild?.classList.add('skr-invoice-totals');
          totals.firstElementChild?.lastElementChild?.classList.add('skr-invoice-grand-total');
        }
        footer.className = 'skr-invoice-footer';
        footer.replaceChildren(node('p', 'skr-invoice-thanks', text('thanks')), node('p', 'skr-invoice-business', 'Samen K&R · KvK 42173688 · Btw-id NL870034996B01'), node('p', 'skr-invoice-contact', 'info@samenkr.com · +31 85 109 13 16 · samenkr.com'));
      }
      const style = document.createElement('style');
      style.textContent = ".skr-invoice-document { padding: 28px !important; margin: 0 !important; color: #1d2935 !important; font-family: Arial, sans-serif !important; background: #fff !important; border: 0 !important; box-shadow: none !important; line-height: 1.5; }\n.skr-invoice-document * { box-sizing: border-box; }\n.skr-invoice-document .skr-invoice-header { display: flex; justify-content: space-between; align-items: center; gap: 24px; padding: 0 0 24px !important; margin: 0 0 22px !important; text-align: left !important; border-bottom: 2px solid #203e5d !important; }\n.skr-invoice-document .skr-invoice-logo { display: block; width: 190px; max-width: 100%; height: auto; margin: 0 0 12px; }\n.skr-invoice-document .skr-invoice-store { color: #203e5d; font-size: 24px; }\n.skr-invoice-document .skr-invoice-address, .skr-invoice-document .skr-invoice-contact { margin: 3px 0 !important; color: #586779 !important; font-size: 11px !important; line-height: 1.6; }\n.skr-invoice-document .skr-invoice-heading { text-align: right; flex-shrink: 0; }\n.skr-invoice-document .skr-invoice-heading h1 { margin: 0 0 4px !important; color: #203e5d !important; font-size: 30px !important; font-family: Arial, sans-serif !important; line-height: 1.2; letter-spacing: -0.5px !important; text-transform: none !important; }\n.skr-invoice-document .skr-invoice-heading p { margin: 0 !important; color: #586779; font-size: 13px !important; }\n.skr-invoice-document .skr-invoice-info { display: grid !important; grid-template-columns: 1fr 1fr; gap: 16px; margin: 0 0 24px !important; font-family: inherit !important; }\n.skr-invoice-document .skr-invoice-info > div { width: auto !important; padding: 16px; border-radius: 9px; background: #f3f6f9; text-align: left !important; }\n.skr-invoice-document .skr-invoice-info > div > p:first-child { margin: 0 0 10px !important; color: #203e5d !important; opacity: 1 !important; font-size: 11px !important; font-weight: 700; letter-spacing: 0.6px !important; }\n.skr-invoice-document .skr-invoice-recipient > p:nth-child(2) { color: #1d2935; font-size: 14px !important; }\n.skr-invoice-document .skr-invoice-recipient > div { margin: 5px 0 0 !important; color: #586779 !important; font-size: 12px !important; line-height: 1.6 !important; }\n.skr-invoice-document .skr-invoice-details > p:not(:first-child) { margin: 4px 0 !important; font-size: 12px !important; }\n.skr-invoice-document .custlo-t1-invoice-table { margin: 0 0 22px !important; font-family: inherit !important; table-layout: fixed; }\n.skr-invoice-document .custlo-t1-invoice-table thead tr { background: #edf3f8 !important; border-color: #dce3e9 !important; }\n.skr-invoice-document .custlo-t1-invoice-table th { padding: 11px 10px !important; color: #203e5d !important; opacity: 1 !important; font-size: 11px !important; font-weight: 700; letter-spacing: 0.4px; }\n.skr-invoice-document .custlo-t1-invoice-table td { padding: 14px 10px !important; color: #354454 !important; font-size: 12px !important; }\n.skr-invoice-document .custlo-t1-invoice-table tr { break-inside: avoid; }\n.skr-invoice-document .custlo-t1-invoice-product_title { font-size: 12px !important; font-weight: 650 !important; line-height: 1.5; }\n.skr-invoice-document .custlo-t1-invoice-product_image { width: 48px !important; height: 48px !important; object-fit: contain !important; border: 1px solid #e2e8ee !important; border-radius: 7px !important; background: #fff; }\n.skr-invoice-document .skr-invoice-totals-wrap { display: flex !important; justify-content: flex-end !important; }\n.skr-invoice-document .skr-invoice-totals { width: 320px !important; max-width: 100%; padding: 18px !important; border-radius: 9px !important; background: #f3f6f9 !important; }\n.skr-invoice-document .skr-invoice-totals > div { font-size: 12px !important; gap: 16px; color: #586779 !important; margin-bottom: 9px !important; }\n.skr-invoice-document .skr-invoice-totals > .skr-invoice-grand-total { margin-bottom: 0 !important; padding-top: 13px !important; margin-top: 13px; border-top: 1px solid #d5dfe8 !important; font-size: 18px !important; color: #203e5d !important; font-weight: 750; }\n.skr-invoice-document .skr-invoice-grand-total span { color: #203e5d !important; }\n.skr-invoice-document .skr-invoice-footer { margin: 24px 0 0 !important; padding: 16px 0 0 !important; border-top: 1px solid #dce3e9 !important; text-align: left !important; font-family: inherit !important; }\n.skr-invoice-document .skr-invoice-thanks { margin: 0 0 7px !important; color: #203e5d !important; font-size: 12px !important; font-style: normal !important; font-weight: 650; }\n.skr-invoice-document .skr-invoice-business { margin: 3px 0 !important; color: #586779 !important; font-size: 10px !important; line-height: 1.6; }\n@media (max-width: 640px) {\n  .skr-invoice-document { padding: 18px !important; }\n  .skr-invoice-document .skr-invoice-header { flex-direction: column; align-items: flex-start; gap: 16px; padding-bottom: 18px !important; margin-bottom: 18px !important; }\n  .skr-invoice-document .skr-invoice-logo { width: 170px; margin-bottom: 9px; }\n  .skr-invoice-document .skr-invoice-heading { display: flex; justify-content: space-between; align-items: center; gap: 12px; width: 100%; text-align: left; }\n  .skr-invoice-document .skr-invoice-heading h1 { font-size: 24px !important; margin: 0 !important; }\n  .skr-invoice-document .skr-invoice-heading p { font-size: 12px !important; text-align: right; }\n  .skr-invoice-document .skr-invoice-info { grid-template-columns: 1fr; gap: 10px; margin-bottom: 18px !important; }\n  .skr-invoice-document .skr-invoice-info > div { padding: 13px; }\n  .skr-invoice-document .custlo-t1-invoice-table td { padding: 5px 0 !important; font-size: 12px !important; }\n  .skr-invoice-document .custlo-t1-invoice-table td::before { color: #586779 !important; opacity: 1 !important; letter-spacing: 0.4px !important; font-size: 10px !important; }\n  .skr-invoice-document .custlo-t1-invoice-product_cell { margin-bottom: 10px; }\n  .skr-invoice-document .skr-invoice-totals { width: 100% !important; padding: 15px !important; }\n  .skr-invoice-document .skr-invoice-footer { margin-top: 20px !important; }\n}\n@media print {\n  .skr-invoice-document { padding: 8mm !important; }\n  .skr-invoice-document .skr-invoice-info { grid-template-columns: 1fr 1fr; }\n  .skr-invoice-document .skr-invoice-header { flex-direction: row; align-items: center; }\n  .skr-invoice-document .skr-invoice-heading { display: block; width: auto; text-align: right; }\n}\n.skr-invoice-document.skr-invoice-export { width: 794px !important; max-width: none !important; padding: 28px !important; }\n.skr-invoice-export .skr-invoice-header { flex-direction: row; align-items: center; gap: 24px; }\n.skr-invoice-export .skr-invoice-heading { display: block; width: auto; text-align: right; }\n.skr-invoice-export .skr-invoice-info { grid-template-columns: 1fr 1fr; }\n.skr-invoice-export .skr-invoice-totals { width: 320px !important; }\n.skr-invoice-export .custlo-t1-invoice-table { display: table !important; }\n.skr-invoice-export .custlo-t1-invoice-table thead { display: table-header-group !important; }\n.skr-invoice-export .custlo-t1-invoice-table tbody { display: table-row-group !important; }\n.skr-invoice-export .custlo-t1-invoice-table tr { display: table-row !important; }\n.skr-invoice-export .custlo-t1-invoice-table td { display: table-cell !important; width: auto !important; padding: 14px 10px !important; text-align: right !important; }\n.skr-invoice-export .custlo-t1-invoice-table td:first-child { text-align: left !important; }\n.skr-invoice-export .custlo-t1-invoice-table td::before { display: none !important; }\n";
      root.prepend(style);
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; enhance(); });
  }).observe(document.body, {childList: true, subtree: true});
  enhance();
})();

